(function() {
  'use strict';

  function variantImageFilter() {
    
    // Color option position (1 = first option, 2 = second, etc.)
    // Change this if color is not your first variant option
    const colorOptionPosition = 1;
    
    // Get selected color from variant selectors
    function getSelectedColor() {
      // Method 1: Radio buttons (Dawn default for color swatches)
      const radioSelector = `fieldset:nth-of-type(${colorOptionPosition}) input[type="radio"]:checked`;
      const selectedRadio = document.querySelector(`variant-radios ${radioSelector}`) ||
                           document.querySelector(radioSelector);
      if (selectedRadio) return selectedRadio.value;

      // Method 2: Dropdown select
      const selectSelector = `select:nth-of-type(${colorOptionPosition})`;
      const selectedSelect = document.querySelector(`variant-selects ${selectSelector}`) ||
                            document.querySelector(selectSelector);
      if (selectedSelect) return selectedSelect.value;

      // Method 3: Get from fieldset legend or header
      const fieldset = document.querySelector(`variant-radios fieldset:nth-of-type(${colorOptionPosition})`);
      if (fieldset) {
        const checkedInput = fieldset.querySelector('input:checked');
        if (checkedInput) return checkedInput.value;
      }

      return null;
    }

    // Filter images based on alt text
    function filterImagesByAlt(colorName) {
      if (!colorName) {
        showAllImages();
        return;
      }

      const colorLower = colorName.toLowerCase().trim();
      
      // Main product images
      const mediaItems = document.querySelectorAll('.product__media-item');
      // Thumbnails
      const thumbnails = document.querySelectorAll('.thumbnail-list__item');
      // Slider dots (if any)
      const sliderDots = document.querySelectorAll('.slider-counter__link');
      
      let visibleCount = 0;
      let firstVisibleItem = null;

      // Filter main images
      mediaItems.forEach((item, index) => {
        const img = item.querySelector('img');
        if (!img) {
          item.style.display = 'none';
          return;
        }

        const altText = (img.alt || '').toLowerCase().trim();
        
        if (altText.includes(colorLower) || colorLower.includes(altText) || altText === colorLower) {
          item.style.display = '';
          item.removeAttribute('hidden');
          visibleCount++;
          if (!firstVisibleItem) firstVisibleItem = item;
        } else {
          item.style.display = 'none';
        }
      });

      // Filter thumbnails
      thumbnails.forEach(thumb => {
        const img = thumb.querySelector('img');
        if (!img) {
          thumb.style.display = 'none';
          return;
        }

        const altText = (img.alt || '').toLowerCase().trim();
        
        if (altText.includes(colorLower) || colorLower.includes(altText) || altText === colorLower) {
          thumb.style.display = '';
        } else {
          thumb.style.display = 'none';
        }
      });

      // If no images match, show all (fallback)
      if (visibleCount === 0) {
        showAllImages();
        return;
      }

      // Scroll to first visible image
      if (firstVisibleItem) {
        const slider = document.querySelector('slider-component');
        if (slider) {
          firstVisibleItem.scrollIntoView({ 
            behavior: 'instant', 
            block: 'nearest', 
            inline: 'start' 
          });
        }
      }

      // Update slider counter if exists
      updateSliderCounter(visibleCount);
    }

    // Show all images (fallback)
    function showAllImages() {
      const allItems = document.querySelectorAll('.product__media-item, .thumbnail-list__item');
      allItems.forEach(item => {
        item.style.display = '';
        item.removeAttribute('hidden');
      });
    }

    // Update slider counter to reflect visible images
    function updateSliderCounter(visibleCount) {
      const counter = document.querySelector('.slider-counter');
      if (counter) {
        const totalSpan = counter.querySelector('.slider-counter__total');
        if (totalSpan) {
          totalSpan.textContent = visibleCount;
        }
      }
    }

    // Initialize on page load
    function init() {
      setTimeout(() => {
        const initialColor = getSelectedColor();
        if (initialColor) {
          filterImagesByAlt(initialColor);
        }
      }, 100);
    }

    // Listen for variant changes - Radio buttons
    document.addEventListener('change', function(e) {
      const target = e.target;
      
      // Check if it's a variant selector
      if (target.matches('input[type="radio"], select')) {
        const isVariantSelector = target.closest('variant-radios') || 
                                  target.closest('variant-selects') ||
                                  target.closest('[data-variant-option]') ||
                                  target.name?.includes('option');
        
        if (isVariantSelector) {
          setTimeout(() => {
            const color = getSelectedColor();
            if (color) {
              filterImagesByAlt(color);
            }
          }, 50);
        }
      }
    });

    // Listen for Dawn theme's custom variant change event
    document.addEventListener('variant:change', function(e) {
      setTimeout(() => {
        const color = getSelectedColor();
        if (color) {
          filterImagesByAlt(color);
        }
      }, 50);
    });

    // Listen for click events on swatches (backup)
    document.addEventListener('click', function(e) {
      const swatch = e.target.closest('label[for*="option"], .swatch, [data-option-value]');
      if (swatch) {
        setTimeout(() => {
          const color = getSelectedColor();
          if (color) {
            filterImagesByAlt(color);
          }
        }, 150);
      }
    });

    // Run initialization
    init();
  }

  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', variantImageFilter);
  } else {
    variantImageFilter();
  }
})();